import React from 'react';

function ProfileStats(props) {
  return <h1 className="font-semibold text-4xl text-center">No stats</h1>;
}

export default ProfileStats;
